import { render, staticRenderFns } from "./mailInfoModal.vue?vue&type=template&id=d1b69d66&scoped=true"
import script from "./mailInfoModal.vue?vue&type=script&lang=js"
export * from "./mailInfoModal.vue?vue&type=script&lang=js"
import style0 from "./mailInfoModal.vue?vue&type=style&index=0&id=d1b69d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b69d66",
  null
  
)

export default component.exports